import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'
import { setInputRows } from '../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../components/procedure/store/procedure.types'
import { getIntubationSelector } from '../selectors'
import { IntubationConstants } from '../store/intubation.constants'
import { IIntubationState } from '../store/intubation.types'

export function* setIndications() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const intubationState: IIntubationState = yield select(getIntubationSelector)
  const { inputRows } = procedureState
  const { indications } = intubationState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === IntubationConstants.SET_INDICATIONS) {
        //@ts-ignore
        input.props.savedValues = indications
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setIndicationsSaga() {
  yield takeLatest([IntubationConstants.SET_INDICATIONS], setIndications)
}
